import React, { PureComponent } from 'react'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { connect } from 'react-redux'
import Icon from 'aria-viewer/tour/components/icon'
import { properCase } from 'aria-viewer/utils/functions'
import Radium from 'radium'
import 'aria-viewer/tour/constants/icons.scss'
import mobileDetect from 'aria-viewer/utils/mobileDetect'

const stopPropagation = e => e.stopPropagation()
const preventDefault = e => e.preventDefault()

const isMobile = mobileDetect.mobile()

const S = {
    iconSvgBase: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
}

export const ButtonIcon = function ButtonIcon({ icon, enabled, pureSvg, svgStyle, iconStyle, className = '' }) {
    if (pureSvg) {
        const style = svgStyle ? Object.assign({}, S.iconSvgBase, svgStyle) : S.iconSvgBase
        return (
            <div
                style={style}
                className={`${icon}_svg ${enabled} puresvg`}
                dangerouslySetInnerHTML={{ __html: styleguide.icons.puresvg[icon] }}
            />
        )
    } else {
        return <Icon className={className} icon={icon} style={iconStyle} />
    }
}
ButtonIcon.displayName = 'ButtonIcon'

class Button extends PureComponent {
    onKeyDown = e => {
        /* Add keyboardfocus to a class of an element that needs control when focused */
        let targetHasKeyboard = e.target.className.indexOf('requiresKeyboardControl') >= 0
        if (!targetHasKeyboard) {
            if (
                e.which === this.props.keyboard &&
                (!this.props.keyboardCtrl || e.ctrlKey) &&
                (!this.props.keyboardAlt || e.altKey)
            ) {
                this.handleOnClick(e)
            }
        }
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
        if (this.props.keyboard) {
            document.addEventListener('keydown', this.onKeyDown)
        }
    }

    componentWillUnmount() {
        if (this.props.keyboard) {
            document.removeEventListener('keydown', this.onKeyDown)
        }
    }

    componentWillReceiveProps(props) {
        if (this.props === props || this.props.theme !== props.theme || this.props.style !== props.style) {
            this.DivStyle = Object.assign(
                {},
                typeof props.theme == 'string' ? styleguide[props.theme] : props.theme,
                props.style
            )
        }
        if (this.props === props || this.props.theme !== props.theme) {
            this.LabelStyle = Object.assign(
                {},
                typeof props.theme == 'string' ? styleguide[props.theme + '_label'] : props.theme && props.theme.label,
                props.labelStyle
            )
        }
        if (this.props === props || this.props.theme !== props.theme) {
            this.IconStyle =
                typeof props.theme == 'string' ? styleguide[props.theme + '_icon'] : props.theme && props.theme.icon
        }
    }

    handleOnClick = e => {
        this.handleButtonPress(e)
    }

    handleButtonPress = e => {
        e.stopPropagation()
        if (this.props.onDispatchClick) {
            this.props.dispatch(this.props.onDispatchClick(e))
        } else if (this.props.onClick) {
            this.props.onClick(e)
        }
    }

    handleKeyPress = e => {
        if (e.key == 'Enter' || ' ' == e.key) {
            this.handleButtonPress(e)
        }
    }

    render() {
        const props = this.props
        const {
            className,
            alt,
            onMouseOver,
            onMouseOut,
            tabIndex,
            icon,
            enabled,
            children,
            puresvg,
            svgStyle,
        } = this.props

        const id = `${this.props.id || props.alt}_button`.replace(' ', '_')

        return (
            <div
                className={className}
                id={id}
                onClick={this.handleOnClick}
                onKeyPress={this.handleKeyPress}
                onTouchMove={stopPropagation}
                onTouchEnd={stopPropagation}
                onTouchCancel={stopPropagation}
                onMouseDown={preventDefault}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                tabIndex={props.tabIndex}
                role="button"
                alt={props.alt || 'button'}
                title={props.altRespectCase || properCase(props.alt) || ''}
                style={this.DivStyle}
            >
                {icon && (
                    <ButtonIcon
                        enabled={enabled}
                        icon={icon}
                        iconStyle={this.IconStyle}
                        pureSvg={puresvg}
                        svgStyle={svgStyle}
                    />
                )}
                <span style={this.LabelStyle}>{children}</span>
            </div>
        )
    }
}

export default connect()(Radium(Button))
